import script from "./CloseFabButtonComponent.vue?vue&type=script&setup=true&lang=tsx"
export * from "./CloseFabButtonComponent.vue?vue&type=script&setup=true&lang=tsx"

import "./CloseFabButtonComponent.vue?vue&type=style&index=0&id=6936d792&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6936d792"]])

export default __exports__